import OnboardingLayout from "@/layouts/OnboardingLayout.vue";
export default {
  path: '/',
  component: OnboardingLayout,
  children: [
    {
      path: '/vendor-onboarding/:token',
      name: 'vendor-onboarding',
      component: () => import('@/views/dashboard/workspaces/_id/vendor-management/add.vue'),
      meta: {
        title: 'Vendor Onboarding',
      }
    },
    {
      path: '/employee-onboarding/:token',
      name: 'employee-onboarding',
      component: () => import('@/views/dashboard/workspaces/_id/employee-management/add.vue'),
      meta: {
        title: 'Employee Onboarding',
      }
    },
    {
      path: '/onboarding/:token',
      name: 'party-onboarding',
      component: () => import('@/views/dashboard/workspaces/_id/onboarding-parties/add.vue'),
      meta: {
        title: 'Onboarding',
        // Same pattern as document-sign: require login, then return here.
        auth: true,
        allowAuthenticated: true,
      }
    },
  ]
}